import React from 'react';

const PosPage = () => {
	return (
		<iframe
			src="https://pos.hamilton-shop.online/signin"
			title="POS System"
			style={{ width: '100%', height: '100vh', border: 'none' }}
		/>
	);
};

export default PosPage;